import { AbstractControl, FormGroup, Validators } from '@angular/forms';
import { TruckSize } from '../../../../../../common/constants';

export function sealPictureControlValidator(formGroup: FormGroup): void {
  const truckSealNumber = formGroup.get('truckSealData').get('sealNumber');
  const truckSealPhoto = formGroup.get('truckSealData').get('data');
  const trailerSealNumber = formGroup.get('trailerSealData').get('sealNumber');
  const trailerSealPhoto = formGroup.get('trailerSealData').get('data');

  const truckSealing = formGroup.get('truckSealData');
  const trailerSealing = formGroup.get('trailerSealData');
  const trailerPlate = formGroup.get('trailerPlate');
  const truckSize = formGroup.get('truckSize');

  validatorLogic(
    formGroup,
    {
      sealNumber: trailerSealNumber,
      plate: trailerPlate,
      sealPhoto: trailerSealPhoto,
      sealing: trailerSealing,
    },
    {
      sealNumber: truckSealNumber,
      size: truckSize,
      sealPhoto: truckSealPhoto,
      sealing: truckSealing,
    },
  );
}

export function sealPictureControlValidatorForTruckSealData(formGroup: FormGroup): void {
  const truckSealNumber = formGroup.get('truckSealData').get('sealNumber');
  const truckSealPhoto = formGroup.get('truckSealData').get('data');
  const trailerSealNumber = formGroup.get('trailerSealData').get('sealNumber');
  const trailerSealPhoto = formGroup.get('trailerSealData').get('data');
  const truckSealing = formGroup.get('truckSealData');
  const trailerSealing = formGroup.get('trailerSealData');
  const trailerPlate = formGroup.get('trailerPlate');
  const truckSize = formGroup.get('truckSize');

  validatorLogic(
    formGroup,
    {
      sealNumber: trailerSealNumber,
      plate: trailerPlate,
      sealPhoto: trailerSealPhoto,
      sealing: trailerSealing,
    },
    {
      sealNumber: truckSealNumber,
      size: truckSize,
      sealPhoto: truckSealPhoto,
      sealing: truckSealing,
    },
  );
}

function validatorLogic(
  formGroup: FormGroup,
  trailer: {
    sealNumber: AbstractControl;
    plate: AbstractControl;
    sealPhoto: AbstractControl;
    sealing: AbstractControl;
  },
  truck: {
    sealNumber: AbstractControl;
    size: AbstractControl;
    sealPhoto: AbstractControl;
    sealing: AbstractControl;
  },
): void {
  if (trailer.plate || truck.size.value === TruckSize.XL || truck.size.value === TruckSize.XXL) {
    setRequiredToControl(truck.sealNumber);
    setRequiredToControl(truck.sealPhoto);
    setRequiredToControl(trailer.sealNumber);
    setRequiredToControl(trailer.sealPhoto);

    if (formGroup.dirty) {
      validateIdAndPhoto(truck.sealNumber, truck.sealPhoto);
      validateIdAndPhoto(trailer.sealNumber, trailer.sealPhoto);
      validateTruckOrTrailerValue(truck.sealNumber, trailer.sealNumber, truck.sealing, trailer.sealing);
    }
  } else {
    setRequiredToControl(truck.sealNumber);
    setRequiredToControl(truck.sealPhoto);
  }
}

function validateIdAndPhoto(id: AbstractControl, photo: AbstractControl): void {
  if (id.value || photo.value) {
    setRequiredToControl(id);
    setRequiredToControl(photo);
  } else {
    removeValidatorsFromControl(id);
    removeValidatorsFromControl(photo);
  }
}

function validateTruckOrTrailerValue(
  truckSealNumber: AbstractControl,
  trailerSealNumber: AbstractControl,
  truckSealing: AbstractControl,
  trailerSealing: AbstractControl,
): void {
  if (!truckSealNumber.value && !trailerSealNumber.value) {
    truckSealing.markAsPristine();
    trailerSealing.markAsPristine();

    setRequiredToControl(truckSealNumber);
    setRequiredToControl(trailerSealNumber);
  }

  if (truckSealNumber.dirty && !trailerSealNumber.value) {
    setRequiredToControl(truckSealing);
    removeValidatorsFromControl(trailerSealing);
  }

  if (trailerSealNumber.dirty && !truckSealNumber.value) {
    setRequiredToControl(trailerSealing);
    removeValidatorsFromControl(truckSealing);
  }
}

function setRequiredToControl(control: AbstractControl): void {
  control.setValidators(Validators.required);
  control.updateValueAndValidity({
    onlySelf: true,
  });
}

function removeValidatorsFromControl(control: AbstractControl): void {
  control.clearValidators();
  control.updateValueAndValidity({
    onlySelf: true,
  });
}
